import "./iconGridItem.scss";
//
import React from "react";
import * as utils from "shell/app/app.utils";
import { Link } from "react-router-dom";
import classNames from "classnames";

export interface iconGridItemData {
  id: string;
  icon: string;
  iconGlow: string;
  label: string;
  overline: string;
  copy: string;
  iconFooter: string;
}

interface iconGridItemProps extends iconGridItemData {
  active: boolean;
  delay: string;
  index: number;
}

const IconGridItem: React.FC<iconGridItemProps> = (props) => {
  return (
    <Link
      to={"#" + props.id}
      className={classNames("icon-grid-item", { "is-active": props.active })}
      style={{ transitionDelay: props.delay, animationDelay: props.delay }}
    >
      <img
        src={utils.assetPath(props.icon)}
        className="icon-grid-item__icon"
        alt=""
      />
      <img
        src={utils.assetPath(props.iconGlow)}
        className="icon-grid-item__icon--active"
        alt=""
      />
      <div className="icon-grid-item__label">{props.label}</div>
    </Link>
  );
};

export default IconGridItem;
